// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e43da623","239":"5210fe8f","732":"035b5107"}[chunkId] + ".chunk.js";
};